<template>
  <div>
    <q-field
        borderless
        v-model="fieldValue"
        :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
    >
    <div class="q-py-sm q-gutter-md mw-form-v2-btn-gutter">

      <template
          v-for="(option, index) in optionsForSelect"
          :key="index"
      >
        <q-btn
          class="mw-form-v2-btn"
          :flat="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.flat: null"
          :rounded="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.rounded: null"
          :round="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.round: null"
          :outline="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.outline: null"
          :push="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.push: null"
          :unelevated="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.unelevated: true"
          :noCaps="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.noCaps: null"
          :glossy="!(settings.theme.button && settings.theme.button.cs) ? settings.theme.button.glossy : null"
          :size="settings.theme.button.size"
          :color="fieldValue === option.value && !(settings.theme.button.colors && settings.theme.button.colors.active)  ? 'secondary' : 'primary'"
          @click="currentVersion = screensVisibilityVersion; fieldValue = option.value"
          :class="{'mw-form-v2-btn-cs':  settings.theme.button.cs, 'mw-form-v2-btn-cs-active':  fieldValue === option.value && settings.theme.button.cs && settings.theme.button.colors.active}"
          :label="option.icon ? null : option.label"
        >
          <div class="mw-form-v2-btn-select-label-box" v-if="option.icon">
          <div class="mw-form-v2-btn-select-image-box" v-if="option.icon">
            <img v-if="option.icon" :src="option.icon" class="mw-form-v2-btn-select-icon mw-form-v2-btn-select-icon-main" />
            <img v-if="option.icon_hover" :src="option.icon_hover" class="mw-form-v2-btn-select-icon mw-form-v2-btn-select-icon-hover" />
          </div>
          <div class="mw-form-v2-btn-select-label" v-html="option.label"></div>
          </div>
          </q-btn>
      </template>

    </div>
    </q-field>
  </div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      value: null,
      currentVersion: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      next: 'values/list/next',
      nextScreen: 'values/list/nextScreen'
    }),
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form',
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      activeScreen: 'activeScreen',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      debug: "debug",
      screensVisibilityVersion: "screensVisibilityVersion"
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      if(this.field.settings_enabled && this.field.settings && this.field.settings.options) {
        data = this.field.settings.options;
      } else {
        for (const [key, value] of Object.entries(this.field.options)) {
          data.push( {
            label: value,
            value: key
          });
        }
      }

      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

  },
  watch: {
    screensVisibilityVersion: function (version) {
      if(this.currentVersion === version -1 && this.field.submit_on_value_set) {
        this.nextScreen({form : this.form});
      }
    }
  },
  mounted() {

  }
}
</script>
<style>

.mw-form-v2-btn-select-icon.mw-form-v2-btn-select-icon-main {
  display: initial;
}

.mw-form-v2-btn-select-icon.mw-form-v2-btn-select-icon-hover {
  display: none;
}
.mw-form-v2-btn:hover .mw-form-v2-btn-select-icon.mw-form-v2-btn-select-icon-main {
  display: none;
}
.mw-form-v2-btn:hover .mw-form-v2-btn-select-icon.mw-form-v2-btn-select-icon-hover {
  display: initial;
}

@media (min-width: 601px) {
  .mw-form-v2-btn-select-icon {
    max-width: 60px;
  }

  .mw-form-v2-btn-select-label-box {
    /*max-width: 120px;*/
    min-width: 90px;
    padding-top: 0.75rem;
    padding-bottom: 0.5rem;
  }

  .mw-form-v2-btn-select-label {
    display: inline-block;
  }
}

@media (max-width: 600px) {
  .mw-form-v2-btn-select-icon {
    max-width: 40px;
  }

  .mw-form-v2-btn-select-label-box {
    /*max-width: 80px;*/
    /*min-width: 40px;*/
    padding-top: 0.5rem;
    padding-bottom: 0.3rem;
  }

  .mw-form-v2-btn-select-label {
    display: inline-block;
    max-width: 100%;
  }
}
</style>
